"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _FoodMenu = require("../../../FoodMenu.context");

var _menu = _interopRequireDefault(require("../../../utils/menu"));

var ModifierSetBasic = function ModifierSetBasic(_ref) {
  var modifierSetId = _ref.modifierSetId;
  return /*#__PURE__*/_react["default"].createElement(_FoodMenu.MenuConsumer, null, function (_ref2) {
    var modifierSets = _ref2.modifierSets,
        modifiers = _ref2.modifiers;

    var modifierSet = _menu["default"].getModifierSetById(modifierSets, modifierSetId);

    var modifierSetModifierIds = modifierSet.modifiers;

    var modifierSetModifiers = _menu["default"].getModifierSetModifiers(modifierSetModifierIds, modifiers);

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "fcfm-modifier-set"
    }, /*#__PURE__*/_react["default"].createElement("h6", null, modifierSet.name), /*#__PURE__*/_react["default"].createElement("ul", null, modifierSetModifiers.map(function (_ref3, index) {
      var name = _ref3.name,
          price = _ref3.price;
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: name
      }, name, price > 0 && ": $".concat(price));
    })));
  });
};

var _default = ModifierSetBasic;
exports["default"] = _default;